// project import
import workspace from './workspace';
import setup from './setup';
import admin from './admin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [workspace, setup, admin]
};

export default menuItems;
